// extracted by mini-css-extract-plugin
module.exports = {"root":"hl8oNWvVB-Mv","section":"Jy-be8d_EkFn","icon_wrapper":"_2nDnpX4KtFQi","icon":"dD9RFfANmtZn"};